export enum ColumnFilterType {
  NONE = 'KEIN FILTER',
  TEXT = 'TEXT',
  TEXTUPPERCASE = 'TEXTUPPERCASE',
  NUMBER = 'NUMBER',
  CURRENCY = 'CURRENCY',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  CHECK = 'CHECK',
  SELECT = 'SELECT',
  MULTISELECT = 'MULTISELECT',
}
